import { GiftIcon, GoalIcon, LucideIcon, ReceiptIcon, TicketIcon } from 'lucide-react'
import { RewardLedgerEntryData, RewardLedgerEntryFromType } from '../types/rewardLedgerEntries.type'

type RecordTypeConfig = {
  label: string
  icon: LucideIcon
}

export const FROM_TYPE_RECORD_MAP: Record<string, RecordTypeConfig> = {
  'Tmais::RewardProductRedemption': { label: 'Resgatou item', icon: GiftIcon },
  'Tmais::Mission': { label: 'Completou missão', icon: GoalIcon },
  'Tmais::RewardTicket': { label: 'Adquiriu bilhete', icon: TicketIcon },
  'Tmais::Consumption': { label: 'Realizou consumo', icon: ReceiptIcon },
}

const ITEM_LABELS = { positive: 'Adquiriu item', negative: 'Resgatou item' }
const TICKET_LABELS = { positive: 'Adquiriu bilhete', negative: 'Gastou bilhete' }

const isItemEntry = (entry: RewardLedgerEntryData) =>
  entry.from_type === 'Tmais::RewardProductRedemption' || entry.reward_type === 'Tmais::Product'

const isTicketEntry = (entry: RewardLedgerEntryData) =>
  entry.from_type === 'Tmais::RewardTicket' || entry.reward_type === 'Tmais::Raffle'

export const getRecordTypeConfig = (entry: RewardLedgerEntryData): RecordTypeConfig => {
  if (entry.from_type === 'Tmais::Mission') return FROM_TYPE_RECORD_MAP['Tmais::Mission']
  if (entry.from_type === 'Tmais::Consumption') return FROM_TYPE_RECORD_MAP['Tmais::Consumption']

  const isNegative = parseFloat(entry.quantity_earned) < 0

  if (isItemEntry(entry)) {
    return { label: isNegative ? ITEM_LABELS.negative : ITEM_LABELS.positive, icon: GiftIcon }
  }

  if (isTicketEntry(entry)) {
    return { label: isNegative ? TICKET_LABELS.negative : TICKET_LABELS.positive, icon: TicketIcon }
  }

  return { label: 'Registro', icon: GiftIcon }
}

export const FROM_TYPE_FILTER_OPTIONS: { label: string; value: RewardLedgerEntryFromType | '' }[] = [
  { label: 'Todos', value: '' },
  { label: 'Resgatou item', value: 'Tmais::RewardProductRedemption' },
  { label: 'Completou missão', value: 'Tmais::Mission' },
  { label: 'Adquiriu bilhete', value: 'Tmais::RewardTicket' },
  { label: 'Realizou consumo', value: 'Tmais::Consumption' },
]

export type CardDisplayType = 'redeemed_item' | 'completed_mission' | 'acquired_ticket' | 'consumption' | 'generic'

export const getCardDisplayType = (entry: RewardLedgerEntryData): CardDisplayType => {
  const fromType = entry.from_type as RewardLedgerEntryFromType | null

  if (fromType === 'Tmais::RewardProductRedemption') return 'redeemed_item'
  if (fromType === 'Tmais::Mission') return 'completed_mission'
  if (fromType === 'Tmais::RewardTicket') return 'acquired_ticket'
  if (fromType === 'Tmais::Consumption') return 'consumption'

  if (entry.reward_type === 'Tmais::Raffle') return 'acquired_ticket'
  if (entry.reward_type === 'Tmais::Product') return 'redeemed_item'

  return 'generic'
}
